import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_courtlevel = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT_LEVEL}/`);
};
export const dispute_resolution_getbyid_courtlevel = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT_LEVEL}/by-id/${id}`);
};
export const dispute_resolution_add_courtlevel = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_COURT_LEVEL}/`, data);
};
export const dispute_resolution_update_courtlevel = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_COURT_LEVEL}/${id}`, data);
};
export const dispute_resolution_delete_courtlevel = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_COURT_LEVEL}/${id}`);
};
